<template>
  <div>
    <h5 class="mb-3">{{ $t("form.industrial_property.files") }}</h5>
    <v-alert v-if="!final && !id" dense text type="info">
      {{ $t("form.industrial_property.save_before_files") }}
    </v-alert>
    <v-card min-height="180" elevation="0" class="industrial-property-files">
      <UploadFiles
        :read-only="readonly"
        object_type="industrial_property"
        :id="id"
        :final="final"
      />
      <v-overlay
        v-if="!final"
        :absolute="true"
        :value="!id"
        :opacity="0.82"
        color="#ffffff"
      >
        <v-btn color="secondary" @click="$emit('save-draft')">
          <v-icon left>mdi-content-save</v-icon>
          {{ $t("button.saveForm") }}
        </v-btn>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import UploadFiles from "@/components/reusables/UploadFiles.vue";

export default {
  name: "IndustrialPropertyFiles",
  components: { UploadFiles },
  props: {
    id: { type: Number, default: null },
    final: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.industrial-property-files {
  position: relative;
}
</style>
